import React from 'react';

import { CompanyType } from 'src/api';
import {
  getRevenueShareInitialValues,
  RevenueShareForm,
  RevenueShareFormValues,
} from 'src/components/revenueShare';
import {
  usePeoPayrollProviderById,
  usePeoPayrollProviderParamId,
  usePeoPayrollProviderRevenueShare,
} from 'src/hooks/peoPayrollProvider';
import { useStripeAccount } from 'src/hooks/stripe';
import {
  PrepareRevenueShareDataActionTypes,
  prepareRevenueShareData,
} from 'src/utils/revenueShare';

export const PeoPayrollProvidersDetailsWallet: React.FC = () => {
  const peoPayrollProviderId = usePeoPayrollProviderParamId();
  const { peoPayrollProvider } = usePeoPayrollProviderById(peoPayrollProviderId);

  const {
    peoPayrollProviderBilling,
    updatePeoPayrollProviderRevenueShare,
    deletePeoPayrollProviderBilling,
    loading: peoPayrollProviderRevenueShareLoading,
  } = usePeoPayrollProviderRevenueShare(peoPayrollProviderId);

  const { stripeAccountStatus, loading: stripeAccountLoading } = useStripeAccount(
    peoPayrollProvider?.stripeAccountId,
  );

  const handleSubmit = React.useCallback(
    async (formValues: RevenueShareFormValues) => {
      try {
        const { revenueShareEnabled, ...formData } = formValues;

        if (revenueShareEnabled) {
          const peoPayrollProviderBillingAction = peoPayrollProviderBilling?.revenueShareSetting
            ? PrepareRevenueShareDataActionTypes.Update
            : PrepareRevenueShareDataActionTypes.Create;

          const dataToSubmit = prepareRevenueShareData(
            peoPayrollProviderBillingAction,
            CompanyType.PeoPayrollProvider,
            formData,
          );
          await updatePeoPayrollProviderRevenueShare(dataToSubmit);
        } else {
          await deletePeoPayrollProviderBilling({
            id: peoPayrollProviderBilling?.revenueShareSetting?.id,
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    [
      deletePeoPayrollProviderBilling,
      peoPayrollProviderBilling?.revenueShareSetting,
      updatePeoPayrollProviderRevenueShare,
    ],
  );

  return (
    <RevenueShareForm
      companyType={CompanyType.PeoPayrollProvider}
      stripeAccountStatus={stripeAccountStatus}
      initialValues={getRevenueShareInitialValues(peoPayrollProviderBilling)}
      handleSubmit={handleSubmit}
      loading={stripeAccountLoading || peoPayrollProviderRevenueShareLoading}
    />
  );
};
